import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-learn-saas',
    templateUrl: './learn-saas.component.html',
    styleUrls: ['./learn-saas.component.scss'],
    standalone: false
})
export class LearnSaasComponent implements OnInit {

  currentTopic = 0;
  currentArcTopic = 0;
  currentOperationTopic = 0;
  saasTopics = [{
    title: 'Architecture & Security',
    imgSrc: '/assets/images/Architecture_Security.svg'
  },
  {
    title: 'Operations & Governance',
    imgSrc: '/assets/images/Operations_Governance.svg'
  },
  {
    title: 'Business Model',
    imgSrc: '/assets/images/Business_Model.svg'
  },
  {
    title: 'Service Assurance',
    imgSrc: '/assets/images/Service_assurance.svg'
  }];
  saasArchitectTopics = ['Integration','Extensibility','Security & Privacy','Platform'];
  saasOperationsTopics = ['Governance','Change Management','Support','Roles & Responsibilities'];

  constructor() { }

  ngOnInit(): void {
  }

  goToTopic(index: number): void {
  this.currentTopic = index;
  }

  goToArchitectTopic(index: number): void {
  this.currentArcTopic = index;
  }

  goToOperations(index: number): void {
    this.currentOperationTopic = index;
  }

}
